import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { deepMix, throttle, upperFirst } from '@antv/util';
import { CustomEvent } from '@antv/g';
import { isTranspose } from '../utils/coordinate';
import { invert, domainOf, abstractOf } from '../utils/scale';
export var SLIDER_CLASS_NAME = 'slider';
function filterDataByDomain(options, scaleOptions, prefix) {
  var hasState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var marks = options.marks;
  var newMarks = marks.map(function (mark) {
    var _a, _b;
    return deepMix({
      // Hide label to keep smooth transition.
      axis: {
        x: {
          transform: [{
            type: 'hide'
          }]
        },
        y: {
          transform: [{
            type: 'hide'
          }]
        }
      }
    }, mark, _defineProperty(_defineProperty({
      scale: scaleOptions
    }, prefix, Object.assign(Object.assign({}, ((_a = mark[prefix]) === null || _a === void 0 ? void 0 : _a.x) && {
      x: Object.assign({
        preserve: true
      }, hasState && {
        ratio: null
      })
    }), ((_b = mark[prefix]) === null || _b === void 0 ? void 0 : _b.y) && {
      y: Object.assign({
        preserve: true
      }, hasState && {
        ratio: null
      })
    })), "animate", false));
  });
  // Rerender and update view.
  return Object.assign(Object.assign({}, options), {
    marks: newMarks,
    clip: true,
    animate: false
  });
}
function abstractValue(values, scale, reverse) {
  var _values = _slicedToArray(values, 2),
    x = _values[0],
    x1 = _values[1];
  var v = reverse ? function (d) {
    return 1 - d;
  } : function (d) {
    return d;
  };
  var d0 = invert(scale, v(x), true);
  var d1 = invert(scale, v(x1), false);
  return domainOf(scale, [d0, d1]);
}
function extentOf(domain) {
  return [domain[0], domain[domain.length - 1]];
}
/**
 * @todo Support click to reset after fix click and dragend conflict.
 */
export function SliderFilter(_ref) {
  var _this = this;
  var channelDomain = _ref.channelDomain,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? SLIDER_CLASS_NAME : _ref$className,
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? 'slider' : _ref$prefix,
    _ref$setValue = _ref.setValue,
    setValue = _ref$setValue === void 0 ? function (component, values) {
      return component.setValues(values);
    } : _ref$setValue,
    _ref$hasState = _ref.hasState,
    hasState = _ref$hasState === void 0 ? false : _ref$hasState,
    _ref$wait = _ref.wait,
    wait = _ref$wait === void 0 ? 50 : _ref$wait,
    _ref$leading = _ref.leading,
    leading = _ref$leading === void 0 ? true : _ref$leading,
    _ref$trailing = _ref.trailing,
    trailing = _ref$trailing === void 0 ? false : _ref$trailing;
  return function (context, _, emitter) {
    var container = context.container,
      view = context.view,
      update = context.update,
      setState = context.setState;
    var sliders = container.getElementsByClassName(className);
    if (!sliders.length) return function () {};
    var filtering = false;
    var scale = view.scale,
      coordinate = view.coordinate,
      layout = view.layout;
    var paddingLeft = layout.paddingLeft,
      paddingTop = layout.paddingTop,
      paddingBottom = layout.paddingBottom,
      paddingRight = layout.paddingRight;
    var scaleX = scale.x,
      scaleY = scale.y;
    var transposed = isTranspose(coordinate);
    var channelOf = function channelOf(orientation) {
      var channel0 = orientation === 'vertical' ? 'y' : 'x';
      var channel1 = orientation === 'vertical' ? 'x' : 'y';
      if (transposed) return [channel1, channel0];
      return [channel0, channel1];
    };
    var sliderHandler = new Map();
    var emitHandlers = new Set();
    // Store current domain of x and y scale.
    if (!channelDomain) {
      channelDomain = {
        x: scaleX.getOptions().domain,
        y: scaleY.getOptions().domain
      };
    }
    var _iterator = _createForOfIteratorHelper(sliders),
      _step;
    try {
      var _loop = function _loop() {
        var slider = _step.value;
        var orientation = slider.attributes.orientation;
        var _channelOf = channelOf(orientation),
          _channelOf2 = _slicedToArray(_channelOf, 2),
          channel0 = _channelOf2[0],
          channel1 = _channelOf2[1];
        var eventName = "".concat(prefix).concat(upperFirst(channel0), ":filter");
        var isX = channel0 === 'x';
        var _scaleX$getOptions = scaleX.getOptions(),
          ratioX = _scaleX$getOptions.ratio;
        var _scaleY$getOptions = scaleY.getOptions(),
          ratioY = _scaleY$getOptions.ratio;
        var domainsOf = function domainsOf(event) {
          // From abstract values.
          if (event.data) {
            var selection = event.data.selection;
            var _selection = _slicedToArray(selection, 2),
              _selection$ = _selection[0],
              X = _selection$ === void 0 ? extentOf(channelDomain.x) : _selection$,
              _selection$2 = _selection[1],
              Y = _selection$2 === void 0 ? extentOf(channelDomain.y) : _selection$2;
            return isX ? [domainOf(scaleX, X, ratioX), domainOf(scaleY, Y, ratioY)] : [domainOf(scaleY, Y, ratioY), domainOf(scaleX, X, ratioX)];
          }
          // From visual values.
          var values = event.detail.value;
          var scale0 = scale[channel0];
          var domain0 = abstractValue(values, scale0, transposed && orientation === 'horizontal');
          var domain1 = channelDomain[channel1];
          return [domain0, domain1];
        };
        var onValueChange = throttle(function (event) {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
            var _event$nativeEvent, nativeEvent, _domainsOf, _domainsOf2, domain0, domain1, X, Y;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  if (!filtering) {
                    _context.n = 1;
                    break;
                  }
                  return _context.a(2);
                case 1:
                  filtering = true;
                  _event$nativeEvent = event.nativeEvent, nativeEvent = _event$nativeEvent === void 0 ? true : _event$nativeEvent; // Get and update domain.
                  _domainsOf = domainsOf(event), _domainsOf2 = _slicedToArray(_domainsOf, 2), domain0 = _domainsOf2[0], domain1 = _domainsOf2[1];
                  channelDomain[channel0] = domain0;
                  channelDomain[channel1] = domain1;
                  if (nativeEvent) {
                    // Emit events.
                    X = isX ? domain0 : domain1;
                    Y = isX ? domain1 : domain0;
                    emitter.emit(eventName, Object.assign(Object.assign({}, event), {
                      nativeEvent: nativeEvent,
                      data: {
                        selection: [extentOf(X), extentOf(Y)]
                      }
                    }));
                  }
                  setState(slider, function (options) {
                    return Object.assign(Object.assign({}, filterDataByDomain(options, _defineProperty(_defineProperty({}, channel0, {
                      domain: domain0,
                      nice: false
                    }), channel1, {
                      domain: domain1,
                      nice: false
                    }), prefix, hasState)), {
                      paddingLeft: paddingLeft,
                      paddingTop: paddingTop,
                      paddingBottom: paddingBottom,
                      paddingRight: paddingRight
                    });
                  });
                  _context.n = 2;
                  return update();
                case 2:
                  filtering = false;
                case 3:
                  return _context.a(2);
              }
            }, _callee);
          }));
        }, wait, {
          leading: leading,
          trailing: trailing
        });
        var emitHandler = function emitHandler(event) {
          var nativeEvent = event.nativeEvent;
          if (nativeEvent) return;
          var data = event.data;
          var selection = data.selection;
          var _selection2 = _slicedToArray(selection, 2),
            X = _selection2[0],
            Y = _selection2[1]; // Update data.
          slider.dispatchEvent(new CustomEvent('valuechange', {
            data: data,
            nativeEvent: false
          }));
          // Update slider.
          var V = isX ? abstractOf(X, scaleX) : abstractOf(Y, scaleY);
          setValue(slider, V);
        };
        emitter.on(eventName, emitHandler);
        slider.addEventListener('valuechange', onValueChange);
        sliderHandler.set(slider, onValueChange);
        emitHandlers.add([eventName, emitHandler]);
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return function () {
      var _iterator2 = _createForOfIteratorHelper(sliderHandler),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            slider = _step2$value[0],
            handler = _step2$value[1];
          slider.removeEventListener('valuechange', handler);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(emitHandlers),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
            name = _step3$value[0],
            _handler = _step3$value[1];
          emitter.off(name, _handler);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    };
  };
}